import {DCIM_SERVER, ASSET_SERVER} from '@/api/server'
import axios from 'axios';
import {athubAxios} from '../../util'
import {RestResource} from '../rest'


//查询分页
function queryPage(queryParams) {
    return new Promise((resolve, reject) => {
        axios.post(`${DCIM_SERVER}/equipment/page`, queryParams
        ).then((responseBody) => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

function queryList(params) {
    return new Promise((resolve, reject) => {
        axios.post(`${DCIM_SERVER}/equipment/list`, params
        ).then((responseBody) => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

//查询可用位置
function queryLocations(roomId) {
    return new Promise((resolve, reject) => {
        axios.get(`${ASSET_SERVER}/location/queryAll?roomId=`+roomId, {}
        ).then((responseBody) => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

function queryDetail(id) {
    return new Promise((resolve, reject) => {
        axios.get(`${DCIM_SERVER}/equipment/${id}`, null
        ).then((responseBody) => {
            if (responseBody.status == 200) {
                resolve(responseBody.data.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

//新增保存
function add(params){
    return new Promise((resolve, reject) => {
       axios.post(`${DCIM_SERVER}/equipment/add`, params
        ).then((responseBody) => {
            if (responseBody.status == 200) {
        resolve(responseBody);
    }
    }).catch(error => {
            reject(error);
    });
    });
}


//修改保存
function update(params){
    return new Promise((resolve, reject) => {
            axios.post(`${DCIM_SERVER}/equipment/update`, params
        ).then((responseBody) => {
            if (responseBody.status == 200) {
        resolve(responseBody);
    }
}).catch(error => {
        reject(error);
});
});
}


//删除
function deleteId(id,userId){
    return new Promise((resolve, reject) => {
            axios.post(`${DCIM_SERVER}/equipment/delete/${id}/${userId}`, null
        ).then((responseBody) => {

            if (responseBody.status == 200) {
        resolve(responseBody.data.data);
    }
}).catch(error => {
        reject(error);
});
});
}


function exportExcel(param){

    return new Promise((resolve, reject) => {
    axios.post(`${DCIM_SERVER}/equipment/exportExcel`, param,{responseType:'blob'}).then(responseBody => {
        if (responseBody.status == 200) {
            let blob = responseBody.data;
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function (e) {
                var a = document.createElement('a');
                a.download = '设备导出结果.xlsx';
                a.href = e.target.result;
                $("body").append(a);
                a.click();
                $(a).remove();
            }
        }

    }).catch(error => {

    });
});
}



function importExcel(params){


    return new Promise((resolve, reject) => {
            let url = `${DCIM_SERVER}/equipment/uploadExcel`;
    let formData = new FormData();
    formData.append("file",params.file)
    axios.post(url, formData).then(responseBody => {
        if (responseBody.status == 200 ) {
        resolve(responseBody.data);
    }else{
        reject(responseBody.data);
    }
}).catch(error => {
        reject(error);
});
});

}
export {
    queryPage,
    queryList,
    queryLocations,
    queryDetail,
    add,
    update,
    deleteId,
    exportExcel,
    importExcel

}

